"use client";
import "./globals.css";
import { Inter, Titan_One } from "next/font/google";
import Configure from "@/app/configure";
import "react-toastify/dist/ReactToastify.css";

const inter = Inter({ subsets: ["latin"] , variable :"--inter-font" });

const titan = Titan_One({ subsets: ["latin"], weight: "400", variable: "--titan-font" });

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return <Configure child={children} inter={inter}/>;
}
